import { useRef } from 'react';
import type { CompulsoryInsurancePenaltyTicketSummary } from '#/components/ui/tickets/compulsory-insurance-penalty/model';

export type ConfirmPaymentOnBehalfDialogRef = {
  confirm: (
    ticket: CompulsoryInsurancePenaltyTicketSummary,
  ) => Promise<boolean>;
};

export const useConfirmPaymentOnBehalfDialog = () => {
  const modalRef = useRef<ConfirmPaymentOnBehalfDialogRef>(null);
  const confirm = (ticket: CompulsoryInsurancePenaltyTicketSummary) =>
    modalRef.current?.confirm(ticket);
  return { props: { modalRef }, confirm };
};
